export const Roles = {
    DEVELOPER: 'DEVELOPER',
    USER: 'USER'
};
